import { useState } from "react"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import { Button, Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material"
import FeaturePermissionsList from "components/feature-permissions/list"
import { ACCOUNT_MEMBER, PERMISSIONED_TOKEN } from "helpers/shapes"
import { FEATURE } from "./shapes"
import { computePermissions, updatePermissions } from "./helpers"
import Loading from "components/loading"

export default function FeaturePermissionsDialog({ show, features, accountFeatures, entityFeatures, entity, entityLabel, onSubmit, onClose, isLoading }) {
  const [featuresToUpdate, setFeaturesToUpdate] = useState({})
  function onChange(featureId, checked) {
    setFeaturesToUpdate({
      ...featuresToUpdate,
      [featureId]: checked,
    })
  }

  function handleUpdate() {
    onSubmit(featuresToUpdate)
  }

  if (!show || isEmpty(entity)) { return null }
  return <Dialog className="components_feature-permissions-dialog" open={show}>
    <DialogTitle>Feature Permissions: {entity.name}</DialogTitle>
    <DialogContent>
      {isLoading ? <Loading /> : <FeaturePermissionsList entityId={entity.id} features={features} accountFeatures={accountFeatures} entityFeatures={entityFeatures} entityLabel={entityLabel} onChange={onChange} />}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={handleUpdate} color="primary">Update</Button>
    </DialogActions>
  </Dialog>
}

FeaturePermissionsDialog.propTypes = {
  entity: PropTypes.oneOfType([ACCOUNT_MEMBER, PERMISSIONED_TOKEN]),
  entityLabel: PropTypes.string,
  show: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  features: PropTypes.arrayOf(FEATURE),
  entityFeatures: PropTypes.arrayOf(FEATURE),
  accountFeatures: PropTypes.arrayOf(FEATURE),
  isLoading: PropTypes.bool,
}

export { computePermissions, updatePermissions, FEATURE, FeaturePermissionsDialog }
